import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	cross_product_tab_label: {
		id: 'product_search_dialog.cross_product.tab_label',
		defaultMessage: 'All',
		description: 'Label to display for the Cross Product search tab',
	},
	cross_product_expanded_input_placeholder: {
		id: 'product_search_dialog.cross_product.expanded.input-placeholder',
		defaultMessage: 'Search All',
		description: 'The placeholder which is visible to the user when Cross Product tab is active ',
	},
	cross_product_recents_section_heading: {
		id: 'product_search_dialog.cross_product.recents.section_heading',
		defaultMessage: 'Recently viewed',
		description: 'The heading to display for the Cross Product recents section',
	},
	cross_product_results_section_heading: {
		id: 'product_search_dialog.cross_product.results.section_heading',
		defaultMessage: 'Search results',
		description: 'The heading to display for the Cross Product results section',
	},
});
